// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgNavigationOffsets = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.037 4C8.368 4 7.015 5.402 7.015 7.132c0 .142.01.28.026.415L7.2 8.789l-1.01.69a3.158 3.158 0 0 0-1.365 2.619c0 1.73 1.353 3.132 3.023 3.132a2.95 2.95 0 0 0 2.082-.863l1.62-1.597 1.288 1.895c.55.81 1.453 1.331 2.474 1.331 1.669 0 3.022-1.402 3.022-3.132a3.17 3.17 0 0 0-.996-2.324l-.951-.891.425-1.254a2.06 2.06 0 0 0 .108-.663c0-1.104-.864-2-1.93-2-.195 0-.38.03-.553.084l-1.237.383-.813-1.039A2.974 2.974 0 0 0 10.037 4zm5.274 13.996a4.791 4.791 0 0 1-2.285-.577V21.5c0 .276-.216.5-.483.5h-1.93a.491.491 0 0 1-.482-.5v-4.848l-.061.033a4.79 4.79 0 0 1-2.223.545c-2.735 0-4.952-2.298-4.952-5.132 0-1.794.888-3.373 2.233-4.29a5.365 5.365 0 0 1-.043-.676C5.085 4.298 7.302 2 10.037 2c1.553 0 2.939.74 3.847 1.9.35-.109.721-.167 1.106-.167 2.13 0 3.858 1.79 3.858 3.999 0 .464-.076.91-.216 1.325a5.203 5.203 0 0 1 1.63 3.807c0 2.835-2.216 5.132-4.951 5.132z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgNavigationOffsets;
